import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const popover: SxStyle = {
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  boxShadow: '0px 2px 1.2px 0px rgba(0, 0, 0, 0.09)',
};

export const content: SxStyle = {
  width: (p) => p.spacing(17.5),
};

export const item: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: (p) => p.spacing(0.5),
  fontSize: (p) => p.typography.caption,
  color: (p) => p.palette.grey[500],
  fontWeight: 500,
};

export const iconWrapper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(0.25),
  borderRadius: (p) => p.spacing(0.5),
};

export const icon: SxStyle = {
  color: (p) => p.palette.grey[600],
};
